var path = 'components/limit-input.tpl.html';
var html = " <div layout=row class=tk-limit-input> <md-input-container flex class=md-block> <label translate>{{ title }}</label> <input ng-required=!unlimited ng-disabled=\"disabled || unlimited\" placeholder=\"{{ 'limit.unlimited' | translate }}\" type=number min=1 step=1 name=limit ng-model=limit> <div ng-messages=theForm.price.$error> <div translate ng-message=required>{{ requiredMessage }}</div> </div> </md-input-container> <md-switch ng-disabled=disabled ng-model=unlimited aria-label=Unlimited> {{ 'limit.unlimited' | translate }} </md-switch> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/limit-input.tpl.html
// module id = 1001
// module chunks = 1